import Vue from 'vue';
import './styles.scss';
import '@/common/init.js';

import routes from '@/routes.js';
import VueYandexMetrika from 'vue-yandex-metrika';
import { createRouter } from '@/router.base.js';
import { METRIC_ID_DEV, METRIC_ID_PROD, METRIC_ID_RC } from './config.js';

import App from './App.vue';


const router = createRouter(routes);

// подключаем метрику
const ignoreRoutes = router.options.routes.filter(route => route.meta.noMetric).map(route => route.name);

let metricId;
if (location.origin.includes('dev')) {
    metricId = METRIC_ID_DEV;
} else if (location.origin.includes('rc')) {
    metricId = METRIC_ID_RC;
} else {
    metricId = METRIC_ID_PROD;
}

Vue.use(VueYandexMetrika, {
    id: metricId,
    env: 'production',
    router,
    ignoreRoutes,
    options: {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: false,
    },
});


const app = new Vue({
    router,
    render: h => h(App),
});

app.$mount('#app');


export default {};
